import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'

export interface WorkingAtGradeLevelResponse {
  working_at_grade_level: {
    at: number
    below: number
    above: number
  }
}

export type WorkingAtGradeLevelData = WorkingAtGradeLevelResponse['working_at_grade_level']

export async function workingAtGradeLevel(
  this: StudentEventsService,
  product: LegacyProductMs | LegacyProductRe | LegacyProductRex,
  studentScope: StatsScope,
  period: NormalizedInterval,
): Promise<Nullable<WorkingAtGradeLevelData>> {
  if (isEmpty(studentScope.ids)) return null

  const url = this.buildUrl('working_at_grade_level', product, studentScope)
  const query = this.buildQuery(studentScope, period)

  const data = await this.fetchData<WorkingAtGradeLevelResponse>(url, query)
  if (!data) return null

  const {
    working_at_grade_level: { below, at, above },
  } = data
  if (below + at + above === 0) {
    return null
  }

  return { below, at, above }
}
